import React, { Component } from "react";
import DaniIcon from "./../../assets/dani_icon.svg";
import FreeDaniIcon from "./../../assets/homa1.png";

import { socketConnection } from "../../socketClient";
import { connect } from "react-redux";
import * as actionCreators from "../../modules/actions/index";
import GoBackComponent from "./GoBackComponent";
import StepReactionsComponent from "./StepReactionsComponent";
import AnswerFeedbackComponent from "./AnswerFeedbackComponent";
import axios from "../../axios";
import * as url from "../../utils/url";
import { toastContainer } from "../../utils/toast";
import moment from "moment";
import TurndownService from "turndown";
import Markdown from "markdown-to-jsx";
import { marked } from "marked";

import { gfm } from "turndown-plugin-gfm";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import { BiChevronsDown, BiShareAlt } from "react-icons/bi";
import { withRouter, useNavigate } from "react-router-dom";
import {
  SHOW_MORE_TYPES,
  Spinner,
  standardizedNLPQuery,
  getMessageTime,
} from "../../utils/constants";
import pdfIcon from "../../assets/icons/pdfIcon.png";
import wordIcon from "../../assets/icons/wordLogo.jpeg";
import parse from "html-react-parser";

class DaniSearchResultStep extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showNotifyOptions: props.step.reaction === -1 ? true : false,
      showMore: true,
      showMoreDropdown: false,
      isRelevantModal: false,
      relevantTools: [],
      isToolsLoading: false,
    };
  }
  componentDidMount() {
    this.props.triggerNextStep(this.props.step);
  }

  handleSearchResultClick = () => {
    const {
      step: { url, description, reaction },
      searchedTerm,
    } = this.props;

    // console.log("dataResult", { url, description, searchedTerm});

    // Socket call for Dani_Question_Submit Event.
    // socketConnection.track("Dani_Result_Click", {
    //   resultUrl : url,
    //   diQuestionText : searchedTerm,
    //   sourceText : description
    // });
    window.open(url, "_blank");
  };

  updateStepReaction = (val) => {
    const newStep = {
      ...this.props.step,
      reaction: val,
    };

    if (val === -1) {
      this.setState({ showNotifyOptions: true, showMore: false });
    } else {
      this.setState({ showNotifyOptions: false, showMore: true });
    }
    this.props.actionTakenOn();

    this.props.updateStep(newStep);
  };

  updateStepDescription = (val) => {
    const newStep = {
      ...this.props.step,
      description: val,
    };

    this.props.updateStep(newStep);
  };

  updateAnswerFeedback = (val) => {
    const newStep = {
      ...this.props.step,
      feedback: val,
    };
    this.props.actionTakenOn();

    this.props.updateStep(newStep);
    this.setState({ showMore: false });
  };

  formattedParagraphs = (para) => {
    var sentencePattern = /[.!?]\s?/;
    let paragraphs = [];
    let res = para;
    var sentences = para.split(sentencePattern);
    sentences = sentences.filter(function(sentence) {
      return sentence.length > 0;
    });
    if (sentences && sentences.length > 4) {
      for (let i = 0; i < sentences.length; i += 5) {
        const group = sentences.slice(i, i + 5);
        let paragraph = "<p>" + group.join(". ") + ". </p>";
        paragraphs.push(paragraph);
      }
      paragraphs = paragraphs.join(" ");
      res = paragraphs;
    } else {
      res = para;
    }
    return res;
  };

  createMarkup = (string) => {
    // const regex = /(?<=\d\.\s)(.*?)(?=\d\.\s|$)/g;
    // const regex = /(\d+\.\s.*?)(?=\d+\.\s|$)/g,
    //   regex2 = /\d+\.\s([^\.]+\.)\s/g,
    //   htmlRegex = /<("[^"]*"|'[^']*'|[^'">])*>/,
    //   remove_num = /\d+\.\s/g,
    //   matchedSentences = string.match(regex)
    //     ? string.match(regex)
    //     : string.match(regex2);
    // let finalString;

    // let input_mdown= <Markdown>{string}</Markdown>

    // console.log('str======== ', string)

    // let input = input_mdown.props.children

    //  console.log('input --- ', input_mdown)

    let m_down = marked.parse(string, {
      breaks: true,
    });

    //  if (
    //   matchedSentences &&
    //   matchedSentences.length > 0 &&
    //   input.indexOf("<table") == -1 &&
    //   input.indexOf("<li") == -1
    // ) {
    //   console.log('FIRST IF --------')
    //   const replacedHTML = input.replace(
    //     /(\d+\.\s.*?)(?=\d+\.\s|$)/g,
    //     "<li>$1</li>"
    //   );
    //   // console.log('replacedHTML --- ', replacedHTML)
    //   const orderedListHTML = `<ol>${replacedHTML}</ol>`.replace(
    //     /<ol>(.*?)<li>/,
    //     "<ol><li>"
    //   );
    //   // console.log('orderedListHTML --- ', orderedListHTML)
    //   // console.log('input --- ', input)
    //   finalString =
    //     input
    //       .replace(/(\d+\.\s.*?)(?=\d+\.\s|$)/g, "")
    //       .replace(/<\/?li>/g, "") + orderedListHTML;
    //   // let clean_str = matchedSentences.map(e=> e.replace(/(\d+\.\s.*?)(?=\d+\.\s|$)/g, '<li>$1</li>').replace(/\d+\.\s/g, ''))
    //   // let li_match = clean_str.join('')
    //   // const orderedListHTML = `<ol>${li_match}</ol>`;
    //   finalString = finalString.replace(/\d+\.\s/g, "");

    //   const prevDiffRegex = /([^.:-<>]+):<\/li>/;

    //   const nextDiffRegex = /([^.:-<>]+):<ol>/;

    //     const prevMatch = finalString.match(prevDiffRegex);

    //     const nextMatch = finalString.match(nextDiffRegex);
    //     if (prevMatch && nextMatch) {
    //       const firstWordToreplace = nextMatch[0];
    //       const secondWordToReplace = prevMatch[0];

    //       finalString = finalString.replace(
    //         firstWordToreplace,
    //         `<br /> <b>${nextMatch[1]}:</b> </br> <ol> `
    //       );
    //       finalString = finalString.replace(
    //         secondWordToReplace,
    //         `</ol> <br /> <b>${prevMatch[1]}:</b> </br> <ol>`
    //       );
    //     }
    // } else {
    //   let res = input
    //   if (input.indexOf("<table") == -1 && input.indexOf("<li") == -1) {
    //     var sentencePattern = /[.!?]\s?/;
    //     var original_paragraphs = input.split("\n")
    //     let formatted_para=[]
    //     console.log('original_paragraphs --- ',original_paragraphs)
    //     if(original_paragraphs && original_paragraphs.length>0){
    //       for(var x=0; x<original_paragraphs.length; x++){
    //         let para = original_paragraphs[x]
    //         // console.log('para --- ', para)
    //         // "<p>" + group.join(". ") + ". </p>";
    //         let p_para =  "<p>" +  this.formattedParagraphs(para) +  "</p>"
    //         console.log('para --- ', p_para)
    //         formatted_para.push(p_para)
    //       }
    //       res = formatted_para.join(" ");
    //       console.log('formatted_para_res ---- ', res)
    //     } else {
    //       res= this.formattedParagraphs(input)
    //     }

    //   } else {
    //     res = input;
    //   }

    //   finalString = res
    // }

    return m_down;
    // parse(m_down)
    // return parse(finalString)
    // input = input.replace(/(\d+)\.\s/g, '<br/><br/>$1. ');
    // return { __html: `<div>${input}</div>` };
  };

  replaceTag = (message) => {
    if (!message) {
      return;
    }

    return message
      .replaceAll("```", "")
      .replaceAll("``", "")
      .replaceAll("`", "");
  };

  parseUrls = (text) => {
    var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
    return text.replace(urlRegex, function(url) {
      return '<a href="' + url + '" target="_blank">' + url + "</a>";
    });
  };

  sanitizeDescription = (text) => {
    let { isDownloadableResponse } = this.props.step;
    if (!text) {
      return " ";
    }
    if (isDownloadableResponse) {
      if (text === "CONSOLIDATE_RESPONSE") {
        const fileMultiPartsData = { ...this.props.fileMultiPartsData };
        const cleanedText = fileMultiPartsData.text
          .replaceAll("Changes Made:", "")
          .replaceAll("Changes made:", "");
        const cleanedChangesMade = fileMultiPartsData.changesMade
          .replaceAll("Changes Made:", "")
          .replaceAll("Changes made:", "");

        const computedText = `${cleanedText} <br/> <b>Changes Made:</b><br/> ${cleanedChangesMade} <br/>`;
        text = computedText;
        this.updateStepDescription(computedText);
        this.props.resetDaniFileMultiPartData();
      } else {
        const changesMadeIndex =
          text.indexOf("Changes made") ||
          text.indexOf("Changes Made") ||
          text.indexOf("Feedback:") ||
          text.indexOf("Changes:");

        if (changesMadeIndex > 0) {
          text = text
            .replace("Changes made:", "<b>Changes made </b><br/>")
            .replace("Changes Made:", "<b>Changes Made </b><br/>")
            .replace("Changes:", "<b>Changes</b><br/>")
            .replace("Feedback:", "<b>Feedback</b><br/>");
        }
      }

      let splitter = "";

      if (text.includes("<br /><b>Changes made </b><br/>")) {
        splitter = "<br /><b>Changes made </b><br/>";
      } else if (text.includes("<br /><b>Changes</b><br/>")) {
        splitter = "<br /><b>Changes</b><br/>";
      } else if (text.includes("<br /><b>Feedback</b><br/>")) {
        splitter = "<br/><b>Feedback</b><br/>";
      }

      if (splitter) {
        let textArr = text.split(splitter);

        if (textArr.length == 2) {
          let newlFormatText = textArr[1];
          newlFormatText = newlFormatText.replaceAll("- ", "<br/> - ");
          textArr[1] = newlFormatText;
          text = textArr.join("<br/>" + splitter);
        }
      }

      // text = text.replace(/\n/g, "<br/>");
    }
    let txt = text
    txt = this.replaceTag(txt);
    String.prototype.replaceAll = function(strReplace, strWith) {
      var esc = strReplace.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
      var reg = new RegExp(esc, "ig");
      return this.replace(reg, strWith);
    };
    return txt
      .replace("As an AI language model", "As a virtual assistant")
      .replace("AI language model", "Virtual assistant")
      .replace("artificial intelligence model", "Virtual assistant")
      .replace("Artificial intelligence model", "Virtual assistant")
      .replace("artificial intelligence model", "Virtual assistant")
      .replaceAll("in HTML", "")
      .replaceAll("HTML", "")
      .replaceAll("html", "")
      .replaceAll("unordered list", "list")
      .replaceAll("Unordered list", "list")
      .replaceAll("ordered list", "list")
      .replaceAll("Ordered list", "list")
      .replaceAll("|->", "-")
      .replaceAll("!’", "-");
  };

  notifyAdmin = (data) => {
    console.log(data);
    const step = {
      id: "",
      trigger: "SEND_ANSWER_FEEDBACK",
      user: true,
      message: `Notify advisor ${data.anonymous ? "anonymously" : ""}`,
    };

    data = { ...data, feedbackQue: this.props.feedbackQueAnswers };
    this.props.setDaniResponseLoading(true);
    this.props.triggerNextStep(step);
    axios
      .post(url.sendAnswerFeedback, data)
      .then(({ data }) => {
        this.props.setDaniResponseLoading(false);

        const storyLink = data.data.storyLink;
        this.props.setFeedbackQue([]);
        const step = {
          id: "",
          trigger: "SEND_ANSWER_FEEDBACK",
          message: `Your advisor has been notified ${
            data.anonymous ? "Anonymously." : "and will be in touch with you."
          }  
          <a target='_blank' href="${storyLink}" class="dani-chat-notify-advisor">Click here to see the story</a>.`,
        };

        this.props.triggerNextStep(step);
        //toastContainer("Notified successfully", "success");
      })
      .catch((err) => {
        this.props.setDaniResponseLoading(false);

        toastContainer(
          "Error occured while sending notification to Admin",
          "error"
        );
        console.log(err);
      });
  };

  toggleShowMoreDropdown = () => {
    this.setState({ showMoreDropdown: !this.state.showMoreDropdown });
  };

  handleShowMoreOptionsClick = (object) => {
    this.props.handleShowMore(object);
    this.props.setFeedbackQue([
      ...this.props.feedbackQueAnswers,
      {
        question: this.props.searchedTerm,
        answer: this.sanitizeDescription(this.props.step.description),
      },
    ]);
    this.setState({ showMore: false });
  };

  handleSocialShare = (data) => {
    const { id, description } = this.props.step;

    const text = document.querySelector(`#export_conversation_${id}`).innerHTML;

    const newStep = {
      ...this.props.step,
    };

    if (data.type === "SLACK") {
      const slackSharedArr = Array.isArray(this.props.step.slackShared)
        ? this.props.step.slackShared
        : [];
      slackSharedArr.push(data.channelId);
      newStep.slackShared = slackSharedArr;
    }

    if (data.type === "TEAMS") {
      const teamsSharedArr = Array.isArray(this.props.step.teamsShared)
        ? this.props.step.teamsShared
        : [];
      teamsSharedArr.push(data.channelId);
      newStep.teamsShared = teamsSharedArr;
    }

    this.props.updateStep(newStep);

    let payload = {
      dani: text,
      user: {
        username: data.isAnonymous
          ? "Anonymous"
          : `${this.props.user.firstName} ${this.props.user.lastName}`,
        text: this.props.previousStep.message,
      },
      channelId: data.channelId,
      channelName: data.channelName,
      type: data.type,
      workSpaceId: data.workSpaceId,
      teamId: data.teamId,
      tenantId: data.tenantId,
    };

    axios
      .post(url.postSocialShare, payload)
      .then(({ data }) => {
        // console.log("data shared----", data);
        //toastContainer("Notified successfully", "success");
      })
      .catch((error) => {
        if (data.type === "SLACK") {
          const slackSharedArr = Array.isArray(this.props.step.slackShared)
            ? this.props.step.slackShared
            : [];
          slackSharedArr.pop(data.channelId);
          newStep.slackShared = slackSharedArr;
        }

        if (data.type === "TEAMS") {
          const teamsSharedArr = Array.isArray(this.props.step.teamsShared)
            ? this.props.step.teamsShared
            : [];
          teamsSharedArr.pop(data.channelId);
          newStep.teamsShared = teamsSharedArr;
        }
        this.props.updateStep(newStep);
        this.props.setDaniResponseLoading(false);
        let message =
          "Error occured while sending message to " + data.type === "SLACK"
            ? "Slack"
            : "Teams";
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors &&
          error.response.data.errors.message === "channel_not_found"
        ) {
          message =
            "Dani is not added as a member to this channel , Please Add Dani as a member to this channel to Post a message";
        }
        toastContainer(message, "error");
      });
  };

  handleToolClick = (tool) => {
    // Passing Dani Props to ToolDetails to identify Dani Navigation
    // let tool_url =  `/home/toolkit/${toolkitCategory}/tool/${tool._id}`
    this.setState({ isRelevantModal: false });
    this.props.history.push({
      pathname: `/home/toolkit/all/tool/${tool._id}`,
    });
  };

  createToolMarkup = (input) => {
    let input_mod = this.sanitizeDescription(input.substring(0, 170)).replace(
      /(<([^>]+)>)/gi,
      ""
    );
    return {
      __html: `<div> ${input_mod}${input.length > 170 ? "..." : ""} </div>`,
    };
  };

  renderRelevantTools = () => {
    let { relevantTools } = this.state;
    if (relevantTools && relevantTools.length > 0) {
      return relevantTools.map((item, idx) => {
        return (
          <div
            className="dani-chat-relevant-tools-container"
            onClick={() => this.handleToolClick(item)}
          >
            <div className="dani-chat-relevant-tools-container-name">
              {idx + 1}. {item.name}
            </div>
            <div
              className="dani-chat-relevant-tools-container-description"
              dangerouslySetInnerHTML={this.createToolMarkup(item.description)}
            />
          </div>
        );
      });
    } else {
      if (this.state.isToolsLoading) {
        return <div>No relevant sources found.</div>;
      } else {
        return <div>Finding relevant sources</div>;
      }
    }
  };

  openRelevantLinksModal = () => {
    let { isRelevantModal } = this.state;
    // this.setState(prevState=> ({
    //   isRelevantModal: !prevState.isRelevantModal
    // }))

    isRelevantModal = !isRelevantModal;
    this.setState({
      isRelevantModal,
      relevantTools: [],
      isToolsLoading: false,
    });

    if (isRelevantModal) {
      let { description, isDownloadableResponse } = this.props.step;
      let message = standardizedNLPQuery(this.sanitizeDescription(description));

      let userMsg = standardizedNLPQuery(this.props.previousStep.message);
      // standardizedNLPQuery
      axios
        .post(url.handleDatabaseQuestion, {
          content: userMsg,
          messages: message,
          // systemType,
        })
        .then(({ data }) => {
          this.setState({
            relevantTools: data.data.result,
            isToolsLoading: true,
          });
        })
        .catch((err) => {
          console.log("err --- ", err);
          this.setState({ relevantTools: [], isToolsLoading: true });
        });
    } else {
      // this.setState({isToolsLoading:false, })
    }
  };

  export2Word = (withQuestion) => {
    const id = withQuestion
      ? `#export_conversation_with_question_${this.props.step.id}`
      : `#export_conversation_${this.props.step.id}`;

    this.props.exportWord(id);
  };

  exportConvoPDF = async (withQuestion) => {
    const id = withQuestion
      ? `#export_conversation_with_question_${this.props.step.id}`
      : `#export_conversation_${this.props.step.id}`;
    this.props.exportPDF(id);
  };

  renderAsHtml = (text) => {
    return parse(this.createMarkup(this.sanitizeDescription(text)));
  };

  render() {
    let {
      title,
      description,
      end,
      searchResults,
      reaction,
      feedback,
      id,
      slackShared,
      teamsShared,
      isDownloadableResponse,
      timeStamp,
      questionAsked,
      selectedOptionId,
    } = this.props.step;
    let { previousStep } = this.props,
      downloaded_response;

    // console.log(this.props.step);

    const { showNotifyOptions, showMore, isRelevantModal } = this.state;

    if (isDownloadableResponse) {
      if (previousStep.id == "fo-1") {
        downloaded_response =
          "Great work! Inclusion is now clearly a priority. Download below.";
      } else if (previousStep.id == "fo-2") {
        downloaded_response =
          "Time to discover the sentiment and learn how it can be improved. Download below.";
      } else if (previousStep.id == "fo-3") {
        downloaded_response =
          "Get a in depth look at what the big ideas are! Download below.";
      }

      if (selectedOptionId == "fo-1") {
        downloaded_response =
          "Great work! Inclusion is now clearly a priority. Download below.";
      } else if (selectedOptionId == "fo-2") {
        downloaded_response =
          "Time to discover the sentiment and learn how it can be improved. Download below.";
      } else if (selectedOptionId == "fo-3") {
        downloaded_response =
          "Get a in depth look at what the big ideas are! Download below.";
      }
    }

    if (description == undefined || description == null) {
      description = "Can you please repeat that?";
    }
    console.log("description --- ", description);
    return (
      <div style={{ position: "relative" }} className={id}>
        <div className="dani-step-container">
          <img
            // style={{ marginBottom: "10px", width: "30px", marginLeft: "15px" }}
            className="dani-chat-profile-icon"
            src={this.props.isFreeDani? FreeDaniIcon :DaniIcon}
          />
          <div
            className="dani-step"
            style={{
              position: "relative",
            }}
          >
            {/*Div for pdf doc downloads*/}
            <div style={{ display: "none" }} charset="UTF-8">
              <div
                id={`export_conversation_with_question_${this.props.step.id}`}
              >
                <div style={{ marginLeft: "15px", width: "640px" }}>
                  <div>
                    <b style={{ fontSize: "15px" }}>
                      {this.props.user.firstName}'s Question:
                    </b>
                  </div>
                  {questionAsked || previousStep.message}
                </div>
                <div
                  style={{
                    marginLeft: "15px",
                    marginTop: "20px",
                    width: "540px",
                  }}
                >
                  <b style={{ fontSize: "15px", width: "540px" }}>
                    Dani's response:
                  </b>
                </div>

                <div
                  style={{ marginLeft: "15px", width: "540px" }}
                  id={`export_conversation_${this.props.step.id}`}
                  className="dani-export-pdf-msg"
                >
                  {description != undefined && description != null
                    ? this.renderAsHtml(description)
                    : "Can you please repeat that?"}
                </div>
              </div>
            </div>

            <div style={{ margin: "14px 1.2rem" }}>
             {parse(description)}
            </div>
            {/* {!isDownloadableResponse ? (
              <div style={{ margin: "14px 1.2rem" }}>
                
                {this.renderAsHtml(description)}
              </div>
            ) : (
              <div
                className=""
                style={{
                  position: "relative",
                  minWidth: "70%",
                }}
              >
                <div className="dani-message-download-msg">
                  {downloaded_response}
                </div>
                <div className="message-download-ui-wrapper">
                  <div className="dani-message-download-component">
                    <img
                      src={pdfIcon}
                      onClick={() => this.exportConvoPDF(false)}
                    />
                    <br />
                    <span>Download as PDF</span>
                  </div>
                  <div
                    className="dani-message-download-component"
                    onClick={() => this.export2Word(false)}
                  >
                    <img src={wordIcon} />
                    <br />
                    <span>Download as Word</span>
                  </div>
                </div>
              </div>
            )}

            {/* {!isDownloadableResponse ? (
              <StepReactionsComponent
                reaction={reaction}
                setReaction={
                  this.props.index ===
                  this.props.current.renderedSteps.length - 2
                    ? this.updateStepReaction
                    : null
                }
                index={this.props.index}
                current={this.props.current}
                handleSocialShare={this.handleSocialShare}
                slackShared={slackShared}
                teamsShared={teamsShared}
                question={this.props.previousStep.message}
                answer={this.renderAsHtml(description)}
                userName={this.props.user.firstName}
                orgId={this.props.user.organizationId&&this.props.user.organizationId._id?this.props.user.organizationId._id:  Math.random().toString(36).slice(2)}
                showPersonaOverlay={this.props.showSettings}
                latestStepId={this.props.latestStepId}
                // current={this.props.current}
                msgId={id}
                showMore={showMore}
                handleShowMoreOptionsClick={this.handleShowMoreOptionsClick}
                openRelevantLinksModal={this.openRelevantLinksModal}
                exportPDF={this.exportConvoPDF}
                export2Word={this.export2Word}
                userId={this.props.user._id}
                organization={this.props.user.organizationId}
              />
            ) : null} */}
          </div>
        </div>
        {timeStamp && (
          <span className="message-timestamp-text">
            {" "}
            {getMessageTime(timeStamp)}{" "}
          </span>
        )}
        {(showMore &&
          id === this.props.latestStepId &&
          this.props.current.previousStep.searchResults) ||
        (reaction == -1 && !isDownloadableResponse) ? (
          <div className="ml-5 mb-2 dani-chat-btn-show-more">
            {reaction == -1 && (
              <AnswerFeedbackComponent
                answer={this.createMarkup(
                  this.sanitizeDescription(description)
                )}
                question={this.props.searchedTerm}
                handleAnswersuccess={() => this.updateAnswerFeedback(1)}
                handleAnswerFailure={(notifydata) => {
                  this.updateAnswerFeedback(-1);
                  this.notifyAdmin(notifydata);
                }}
                showNotifyOptions={
                  showNotifyOptions &&
                  reaction === -1 &&
                  ![-1, 1].includes(feedback)
                }
                triggerInput={() => {
                  const step = {
                    id: "",
                    trigger: "SEND_ANSWER_FEEDBACK",
                    user: true,
                    message: `Dont notify`,
                  };

                  this.props.triggerNextStep(step);
                }}
              />
            )}
          </div>
        ) : null}

        <Modal
          isOpen={isRelevantModal}
          className="dashboardModalContainer dashboardModalDetailsContainer"
        >
          <ModalHeader
            toggle={() => this.openRelevantLinksModal()}
            className="dashboardHeader"
            charCode="X"
          >
            <div className="dashboardModalTitle">Sources</div>
          </ModalHeader>

          <ModalBody className={"dani-channel-modal"}>
            {/* <img src={Spinner} className="spinner-pos" /> */}
            {!this.state.isToolsLoading ? (
              <img src={Spinner} className="spinner-pos" />
            ) : (
              this.renderRelevantTools()
            )}
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    navBar: state.navBar,
    user: state.user.profile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onLogoutSuccess: (data) => dispatch(actionCreators.logout()),
    onUpdateUserSuccess: (data) =>
      dispatch(actionCreators.updateUserSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(DaniSearchResultStep));
